/** /quiz-buzzer — small shared helpers: strings, formatting, storage, DOM. */
export const CFG = window.__QB_CFG || { t: {}, locale: 'en' };
export const SLUG = 'quiz-buzzer';
/** Room ids on the broker are PREFIX + code; bump PROTO when the messages change shape. */
export const PREFIX = 'qbz-';
export const PROTO = 1;

/** Localised string with :placeholders. Missing keys fall back to the key (visible in QA, never silent). */
export function t(key, vars) {
    let s = CFG.t[key];
    if (s == null) s = key;
    if (vars) {
        // Longest names first, so :n never eats the start of :name.
        Object.keys(vars).sort(function (a, b) { return b.length - a.length; })
            .forEach(function (k) { s = s.split(':' + k).join(String(vars[k])); });
    }
    return s;
}

export function $(id) { return document.getElementById(id); }

export function el(tag, cls, text) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
}

let nf3 = null, nf0 = null;
// Western digits everywhere (Arabic too): the numbers sit next to the page's own
// Western-digit text, and a mixed-script scoreboard is harder to read at a glance.
const NUM_LOCALE = ({ ar: 'ar-u-nu-latn', es: 'es-419' })[CFG.locale] || CFG.locale || 'en';   // es: Latin American decimal point
function fmt3() { return nf3 || (nf3 = new Intl.NumberFormat(NUM_LOCALE, { minimumFractionDigits: 3, maximumFractionDigits: 3 })); }
function fmt0() { return nf0 || (nf0 = new Intl.NumberFormat(NUM_LOCALE, { maximumFractionDigits: 0 })); }

/** 412.3 → «0.412 s» in the page locale. */
export function secs(ms) { return t('u_sec', { n: fmt3().format(ms / 1000) }); }
/** 37.4 → «37 ms». */
export function msec(ms) { return t('u_ms', { n: fmt0().format(Math.round(ms)) }); }
export function num(n) { return fmt0().format(n); }
/** Countdown text: 7.2 s → «8», 65 s → «1:05». */
export function clock(ms) {
    const s = Math.max(0, Math.ceil(ms / 1000));
    if (s < 60) return String(s);
    return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
}

export function store(key, value) {
    try {
        if (window.__toolSettings && window.__toolSettings.save) window.__toolSettings.save(SLUG, key, value);
    } catch (e) { /* storage blocked: the game still works, it just will not resume */ }
}
export function load(key, fallback) {
    try {
        if (window.__toolSettings && window.__toolSettings.load) return window.__toolSettings.load(SLUG, key, fallback);
    } catch (e) { /* see store() */ }
    return fallback;
}

export function toast(msg, type) { try { if (window.__toast) window.__toast(msg, type || 'info'); } catch (e) { /* no toast layer */ } }
export function stage(name, meta) { try { if (window.__stage) window.__stage(name, meta || {}); } catch (e) { /* telemetry is optional */ } }
export function diag(issue, data) { try { if (window.__aeDiagnostic) window.__aeDiagnostic(Object.assign({ issue: issue }, data || {})); } catch (e) { /* optional */ } }
export function funnel(step, data) { try { if (window.__aeFunnel) window.__aeFunnel(step, data || {}); } catch (e) { /* optional */ } }

/** Cryptographically random id (player ids, team ids). */
export function rid(n) {
    const a = new Uint8Array(n || 8);
    crypto.getRandomValues(a);
    return Array.from(a, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
}

/** Only printable text, trimmed and capped: names travel to every screen in the room. */
export function cleanName(s, max) {
    return String(s || '').replace(/[\u0000-\u001f\u007f-\u009f\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '').replace(/\s+/g, ' ').trim().slice(0, max || 24);
}

/** An input event's own timestamp when it is on the performance.now() scale, else now. */
export function evStamp(e) {
    const n = performance.now();
    const ts = e && e.timeStamp;
    return (typeof ts === 'number' && ts > 0 && ts <= n + 1 && n - ts < 5000) ? ts : n;
}

export function vibrate(pattern) { try { if (navigator.vibrate) navigator.vibrate(pattern); } catch (e) { /* iOS: no vibration API */ } }

export const PALETTE = ['#ef4444', '#3b82f6', '#22c55e', '#f59e0b', '#a855f7', '#ec4899', '#14b8a6', '#f97316', '#84cc16', '#06b6d4', '#eab308', '#6366f1'];

/** Readable text colour on a player colour. */
export function inkOn(hex) {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
    if (!m) return '#fff';
    const v = parseInt(m[1], 16);
    const r = (v >> 16) & 255, g = (v >> 8) & 255, b = v & 255;
    return (0.299 * r + 0.587 * g + 0.114 * b) > 160 ? '#111' : '#fff';
}

export function editable(target) {
    if (!target || !target.closest) return false;
    return !!target.closest('input, textarea, select, [contenteditable="true"], [contenteditable=""]');
}
